/* eslint-disable no-unused-vars */
import React, { useContext, useMemo } from 'react';
import { Link } from 'react-router-dom';

import _ from 'underscore';

import injectSheet from 'react-jss';

import useQlikSessionObject from 'hooks/useQlikSessionObject';
import Kpi from './Kpi';
import Table from './Table';

import CurrentTournamentStyles from './Current_Toutnament_Styles';

/* Qlik */
import AppContext from '../AppContext';

import groupStandingsQProp from '../../config/hypercubeDefs/groupStandingsQProp';
import bracketStandingsQProp from '../../config/hypercubeDefs/bracketStandingsQProp';

const styles = CurrentTournamentStyles;

const currentTournament = ({ classes }) => {
  const qlikApp = useContext(AppContext);

  const qGroupStandingsData = useQlikSessionObject({
    app: qlikApp,
    properties: groupStandingsQProp,
  });

  console.log('qGroupStandingsData -> ', qGroupStandingsData);

  const qBracketData = useQlikSessionObject({
    app: qlikApp,
    properties: bracketStandingsQProp,
  });

  const qGroupStandings = useMemo(() => {
    if (!qGroupStandingsData.layout) return [];

    let qlikDataGroupStandings = [];

    if (qGroupStandingsData.layout.qHyperCube.qError) {
      qlikDataGroupStandings = [];
    } else {
      qlikDataGroupStandings = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H']
        .map((group) => _.groupBy(qGroupStandingsData.layout.qHyperCube.qDataPages[0].qMatrix, (d) => d[2].qText)[group]) // eslint-disable-line no-undef
        .filter((group) => group !== undefined);
    }
    return qlikDataGroupStandings;
  }, [qGroupStandingsData.layout]);

  const qBracket = useMemo(() => {
    if (!qBracketData.layout) return [];

    let qlikDataBracket = [];

    if (qBracketData.layout.qHyperCube.qError) {
      qlikDataBracket = [];
    } else {
      qlikDataBracket = qBracketData.layout.qHyperCube.qDataPages[0].qMatrix;
    }
    return qlikDataBracket;
  }, [qBracketData.layout]);

  return (
    <div className={classes.wrapper}>
      <div className={classes.header} style={{ borderBottom: '1px solid lightgray', fontSize: 26 }}>
        <div style={{ display: 'flex', justifyContent: 'space-around', padding: '10px 0' }}>
          <Link to="/historical-analysis/" style={{ textDecoration: 'none', color: '#787878', '& :hover': { color: '#63AC1F' } }}>
            TOURNAMENT STATS
          </Link>
          <div className={classes.nav}>
            {/* <div className={classes.liveResults}>Live</div> */}
            <div className={classes.nav} style={{ color: '#7F1431' }}>
              2022 RESULTS
            </div>
          </div>
        </div>
      </div>

      {/* KPIs */}

      <div className={classes.kpis} style={{ padding: 20 }}>
        <div className={classes.kpi}>
          <div className={classes.kpititle}>Games Played</div>
          <div className={classes.kpinum}>
            <Kpi measure="Count(total [Home Team Goals])" />
            <div className={classes.kpisuffix}>&nbsp;out of 64</div>
          </div>

        </div>
        <div className={classes.kpi}>
          <div className={classes.kpititle}>Goals Scored</div>
          <div className={classes.kpinum}>
            <Kpi measure="Sum([Home Team Goals]+[Away Team Goals])" />
          </div>
        </div>
        <div className={classes.kpi}>
          <div className={classes.kpititle}>Goals per game</div>
          <div className={classes.kpinum}>
            <Kpi measure="Num(Sum([Home Team Goals]+[Away Team Goals]) / Count(total [Home Team Goals]), '##.00')" />
          </div>
        </div>
      </div>

      {/* Groups / Matchups */}

      <div className={classes.currenttournamet} style={{ }}>
        <div className={classes.sidebar}>
          <div className={classes.head}>GROUP STAGE</div>
          <div className={classes.groups}>
            {qGroupStandings.map((group) => (
              <div key={group[0][0].qElemNumber}>
                <table className={classes.tablegroups}>
                  <thead className={classes.thead}>
                    <tr>
                      <th className={classes.th} style={{ fontWeight: 'bold' }}>
                        Group
                        {' '}
                        {group[0][2].qText}
                      </th>
                      <th className={classes.th}>Pts</th>
                      <th className={classes.th}>Goals</th>
                      <th className={classes.th}>Dif.</th>
                    </tr>
                  </thead>
                  <tbody className={classes.tbody}>
                    <tr className={classes.in}>
                      <td className={classes.teamname}>{group[0][1].qText}</td>
                      <td>{group[0][3].qText}</td>
                      <td>{group[0][4].qText}</td>
                      <td>{(group[0][4].qNum - group[0][5].qNum) || 0}</td>
                    </tr>
                    <tr className={classes.in}>
                      <td className={classes.teamname}>{group[1][1].qText}</td>
                      <td>{group[1][3].qText}</td>
                      <td>{group[1][4].qText}</td>
                      <td>{(group[1][4].qNum - group[1][5].qNum) || 0}</td>
                    </tr>
                    <tr className={classes.out}>
                      <td className={classes.teamname}>{group[2][1].qText}</td>
                      <td>{group[2][3].qText}</td>
                      <td>{group[2][4].qText}</td>
                      <td>{(group[2][4].qNum - group[2][5].qNum) || 0}</td>
                    </tr>
                    <tr className={classes.out}>
                      <td className={classes.teamname}>{group[3][1].qText}</td>
                      <td>{group[3][3].qText}</td>
                      <td>{group[3][4].qText}</td>
                      <td>{(group[3][4].qNum - group[3][5].qNum) || 0}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            ))}
          </div>
        </div>

        {/* Matchups */}
        <div className={classes.content}>
          <div className={classes.head}>GROUP STAGE MATCHUPS</div>

          <div style={{
            height: '490px', overflow: 'auto', fontSize: 13, fontFamily: 'Roboto',
          }}
          >
            <Table
              matches
              colHeadStyles={[{}, {}, { textAlign: 'center' }, { textAlign: 'center' }, {}, { textAlign: 'center' }, { textAlign: 'right', paddingRight: '1em' }]}
              colStyles={[{ color: '#787878' }, { color: '#787878', padding: '4px 0' }, { color: '#787878', justifyContent: 'center', fontSize: 13 }, { color: '#787878', justifyContent: 'center', fontSize: 13 }, { color: '#787878' }, { color: '#787878', justifyContent: 'center' }, { color: '#787878', display: 'flex', flexDirection: 'row-reverse' }]}
              sortCol={2}
              headings={['MATCH #', 'GROUP', 'DATE', 'UTC/GMT +3', 'HOME TEAM', 'AWAY TEAM', 'SCORE']}
              displayOrder={[0, 1, 2, 3, 4, 6, 5]}
              dimensions={[
                {
                  qDef: {
                    qFieldDefs: ['Game'],
                    qSortCriterias: [
                      {
                        qSortByNumeric: 1,
                      },
                    ],
                  },
                  qNullSuppression: true,
                },
                {
                  qDef: {
                    qFieldDefs: ['Group'],
                  },
                  qNullSuppression: true,
                },
                {
                  qDef: {
                    qFieldDefs: ['Date'],
                    qSortCriterias: [{
                      qSortByAscii: 1,
                    }],
                  },
                  qNullSuppression: true,
                },
                {
                  qDef: {
                    qFieldDefs: ["=Time(Time,'hh:mm')"],
                  },
                  qNullSuppression: true,
                },
                {
                  qDef: {
                    qFieldDefs: ['Home Team'],
                  },
                  qAttributeExpressions: [{ qExpression: '=only(Home Team)' }],
                  qNullSuppression: true,
                },
                {
                  qDef: {
                    qFieldDefs: ['Away Team'],
                  },
                  qAttributeExpressions: [{ qExpression: '=only(Away Team)' }],
                  qNullSuppression: true,
                },
              ]}
              measures={[
                {
                  qDef: {
                    qDef: "=Only(['Home Team Goals']) & ' - ' & Only(['Away Team Goals'])",
                  },
                },
              ]}
            />
          </div>
        </div>

      </div>

      {/* Knockouts */}

      <div style={{ padding: '30px 15px', borderBottom: '10px solid #F4F5F0', marginBottom: 50 }}>
        <div className={classes.head}>KNOCKOUT STAGE</div>
        <div className={classes.bracket}>
          <div className={classes.bracketcontent}>
            {/* Leftside of the Bracket */}
            {/* Eighths */}
            <div className={classes.eighths_left}>
              <div className={classes.match_left}>
                <div className={classes.game}>
                  <div>
                    {qBracket.length && qBracket[0][1].qText}
                  </div>
                </div>
                <div className={classes.nowrap}>{qBracket.length && (`${qBracket[0][3].qText} - ${qBracket[0][4].qText}`)}</div>
                <div className={classes.nowrap}>{qBracket.length && qBracket[0][5].qText}</div>
                <div className={classes.game}>
                  <div>
                    {qBracket.length && qBracket[0][2].qText}
                  </div>
                </div>
              </div>
              <div className={classes.match_left}>
                <div className={classes.game}>
                  <div>
                    {qBracket.length && qBracket[1][1].qText}
                  </div>
                </div>
                <div className={classes.nowrap}>{qBracket.length && (`${qBracket[1][3].qText} - ${qBracket[1][4].qText}`)}</div>
                <div className={classes.nowrap}>{qBracket.length && qBracket[1][5].qText}</div>
                <div className={classes.game}>
                  <div>
                    {qBracket.length && qBracket[1][2].qText}
                  </div>
                </div>
              </div>
              <div className={classes.match_left}>
                <div className={classes.game}>
                  <div>
                    {qBracket.length && qBracket[4][1].qText}
                  </div>
                </div>
                <div className={classes.nowrap}>{qBracket.length && (`${qBracket[4][3].qText} - ${qBracket[4][4].qText}`)}</div>
                <div className={classes.nowrap}>{qBracket.length && qBracket[4][5].qText}</div>
                <div className={classes.game}>
                  <div>
                    {qBracket.length && qBracket[4][2].qText}
                  </div>
                </div>
              </div>
              <div className={classes.match_left}>
                <div className={classes.game}>
                  <div>
                    {qBracket.length && qBracket[5][1].qText}
                  </div>
                </div>
                <div className={classes.nowrap}>{qBracket.length && (`${qBracket[5][3].qText} - ${qBracket[5][4].qText}`)}</div>
                <div className={classes.nowrap}>{qBracket.length && qBracket[5][5].qText}</div>
                <div className={classes.game}>
                  <div>
                    {qBracket.length && qBracket[5][2].qText}
                  </div>
                </div>
              </div>
            </div>
            {/* Quarters */}
            <div className={classes.quarters_left}>
              <div className={classes.match_left}>
                <div className={classes.game}>
                  <div>
                    {qBracket.length && qBracket[9][1].qText}
                  </div>
                </div>
                <div className={classes.nowrap}>{qBracket.length && (`${qBracket[9][3].qText} - ${qBracket[9][4].qText}`)}</div>
                <div className={classes.nowrap}>{qBracket.length && qBracket[9][5].qText}</div>
                <div className={classes.game}>
                  <div>
                    {qBracket.length && qBracket[9][2].qText}
                  </div>
                </div>
              </div>
              <div className={classes.spacer} />
              <div className={classes.match_left}>
                <div className={classes.game}>
                  <div>
                    {qBracket.length && qBracket[8][1].qText}
                  </div>
                </div>
                <div className={classes.nowrap}>{qBracket.length && (`${qBracket[8][3].qText} - ${qBracket[8][4].qText}`)}</div>
                <div className={classes.nowrap}>{qBracket.length && qBracket[8][5].qText}</div>
                <div className={classes.game}>
                  <div>
                    {qBracket.length && qBracket[8][2].qText}
                  </div>
                </div>
              </div>
            </div>
            {/* Semis */}
            <div className={classes.semis_left}>
              <div className={classes.match_left}>
                <div className={classes.game}>
                  <div>
                    {qBracket.length && qBracket[12][1].qText}
                  </div>
                </div>
                <div className={classes.nowrap}>{qBracket.length && (`${qBracket[12][3].qText} - ${qBracket[12][4].qText}`)}</div>
                <div className={classes.nowrap}>{qBracket.length && qBracket[12][5].qText}</div>
                <div className={classes.game}>
                  <div>
                    {qBracket.length && qBracket[12][2].qText}
                  </div>
                </div>
              </div>
            </div>
            {/* Finals */}
            <div className={classes.finals}>
              <div className={classes.final}>
                <div className={classes.game}>
                  <div>
                    <img src="assets/images/world-cup-icon.png" alt="world cup icon" style={{ width: 24 }} />
                    {' '}
                    {qBracket.length && qBracket[15][1].qText}
                  </div>
                </div>
                <div className={classes.nowrap}>{qBracket.length && (`${qBracket[15][3].qText} - ${qBracket[15][4].qText}`)}</div>
                <div className={classes.nowrap}>
                  1
                  {qBracket.length && qBracket[15][5].qText}
                </div>
                <div className={classes.game}>
                  <div>
                    {'(2)'}
                    {' '}
                    {qBracket.length && qBracket[15][2].qText}
                  </div>
                </div>
              </div>
              <div className={classes.thirdfourth}>
                <div className={classes.game}>
                  <div>
                    {'(3)'}
                    {' '}
                    {qBracket.length && qBracket[14][1].qText}
                  </div>
                </div>
                <div className={classes.nowrap}>{qBracket.length && (`${qBracket[14][3].qText} - ${qBracket[14][4].qText}`)}</div>
                <div className={classes.nowrap}>{qBracket.length && qBracket[14][5].qText}</div>
                <div className={classes.game}>
                  <div>
                    {'(4)'}
                    {' '}
                    {qBracket.length && qBracket[14][2].qText}
                  </div>
                </div>
              </div>
            </div>
            {/* Right Side of Bracket */}
            {/* Semis  */}
            <div className={classes.semis_right}>
              <div className={classes.match_right}>
                <div className={classes.game}>
                  <div>
                    {qBracket.length && qBracket[13][1].qText}
                  </div>
                </div>
                <div className={classes.nowrap}>{qBracket.length && (`${qBracket[13][3].qText} - ${qBracket[13][4].qText}`)}</div>
                <div className={classes.nowrap}>{qBracket.length && qBracket[13][5].qText}</div>
                <div className={classes.game}>
                  <div>
                    {qBracket.length && qBracket[13][2].qText}
                  </div>
                </div>
              </div>
            </div>
            {/* Quarters */}
            <div className={classes.quarters_right}>
              <div className={classes.match_right}>
                <div className={classes.game}>
                  <div>
                    {qBracket.length && qBracket[11][1].qText}
                  </div>
                </div>
                <div className={classes.nowrap}>{qBracket.length && (`${qBracket[11][3].qText} - ${qBracket[11][4].qText}`)}</div>
                <div className={classes.nowrap}>{qBracket.length && qBracket[11][5].qText}</div>
                <div className={classes.game}>
                  <div>
                    {qBracket.length && qBracket[11][2].qText}
                  </div>
                </div>
              </div>
              <div className={classes.match_right}>
                <div className={classes.game}>
                  <div>
                    {qBracket.length && qBracket[10][1].qText}
                  </div>
                </div>
                <div className={classes.nowrap}>{qBracket.length && (`${qBracket[10][3].qText} - ${qBracket[10][4].qText}`)}</div>
                <div className={classes.nowrap}>{qBracket.length && qBracket[10][5].qText}</div>
                <div className={classes.game}>
                  <div>
                    {qBracket.length && qBracket[10][2].qText}
                  </div>
                </div>
              </div>
              <div className={classes.spacer} />
            </div>
            {/* Eighths */}
            <div className={classes.eighths_right}>
              <div className={classes.match_right}>
                <div className={classes.game}>
                  <div>
                    {qBracket.length && qBracket[3][1].qText}
                  </div>
                </div>
                <div className={classes.nowrap}>{qBracket.length && (`${qBracket[3][3].qText} - ${qBracket[3][4].qText}`)}</div>
                <div className={classes.nowrap}>{qBracket.length && qBracket[3][5].qText}</div>
                <div className={classes.game}>
                  <div>
                    {qBracket.length && qBracket[3][2].qText}
                  </div>
                </div>
              </div>
              <div className={classes.match_right}>
                <div className={classes.game}>
                  <div>
                    {qBracket.length && qBracket[2][1].qText}
                  </div>
                </div>
                <div className={classes.nowrap}>{qBracket.length && (`${qBracket[2][3].qText} - ${qBracket[2][4].qText}`)}</div>
                <div className={classes.nowrap}>{qBracket.length && qBracket[2][5].qText}</div>
                <div className={classes.game}>
                  <div>
                    {qBracket.length && qBracket[2][2].qText}
                  </div>
                </div>
              </div>
              <div className={classes.match_right}>
                <div className={classes.game}>
                  <div>
                    {qBracket.length && qBracket[6][1].qText}
                  </div>
                </div>
                <div className={classes.nowrap}>{qBracket.length && (`${qBracket[6][3].qText} - ${qBracket[6][4].qText}`)}</div>
                <div className={classes.nowrap}>{qBracket.length && qBracket[6][5].qText}</div>
                <div className={classes.game}>
                  <div>
                    {qBracket.length && qBracket[6][2].qText}
                  </div>
                </div>
              </div>
              <div className={classes.match_right}>
                <div className={classes.game}>
                  <div>
                    {qBracket.length && qBracket[7][1].qText}
                  </div>
                </div>
                <div className={classes.nowrap}>{qBracket.length && (`${qBracket[7][3].qText} - ${qBracket[7][4].qText}`)}</div>
                <div className={classes.nowrap}>{qBracket.length && qBracket[7][5].qText}</div>
                <div className={classes.game}>
                  <div>
                    {qBracket.length && qBracket[7][2].qText}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default injectSheet(styles)(currentTournament);
